import React from 'react'
import { Card, PageTitle, StatusBadge, formatDate } from '../components/Ui'
import { BackLink, DetailGrid, SummaryGrid, Tags, Timeline } from '../components/AdminCommon'
import { mockupJobs } from '../data/parityDetailData'

export default function MockupJobDetail({ id, navigate }) {
  const item = mockupJobs.find((row) => row.id === id) || mockupJobs[0]
  return <>
    <BackLink onClick={() => navigate('/ai/mockups')} />
    <PageTitle eyebrow="AI MOCKUP JOB" title={item.id} description="디렉터가 견적 작성 중 생성한 AI 시안의 입력·모델·품질·선택 계보를 확인합니다." />
    <SummaryGrid items={[
      { label: '상태', value: <StatusBadge status={item.status} /> },
      { label: '품질', value: item.quality },
      { label: '생성 결과', value: `${item.outputCount}개` },
      { label: '비용', value: `$${item.costUsd.toFixed(2)}` },
    ]} />
    <div className="dashboard-grid half">
      <Card title="작업 정보"><DetailGrid items={[
        { label: '견적번호', value: item.quoteNo }, { label: '견적 요청', value: item.requestNo },
        { label: '디렉터', value: item.director }, { label: '생성 시각', value: formatDate(item.createdAt, true) },
        { label: '모델 Snapshot', value: item.model, wide: true }, { label: 'Prompt Version', value: item.promptVersion, wide: true },
      ]} /></Card>
      <Card title="입력·계보"><div className="admin-detail-stack"><div><span>입력 파일</span><Tags items={item.inputFiles} /></div><div><span>부모 시안</span><strong>{item.parentAsset || '최초 생성'}</strong></div><div><span>디렉터 선택 여부</span><strong>{item.selected ? '선택됨' : '선택 안 됨'}</strong></div></div></Card>
    </div>
    {item.error && <Card title="생성 오류"><div className="admin-long-text">{item.error}</div></Card>}
    <Card title="작업 이력"><Timeline items={[
      { label: '시안 생성 요청', detail: `${item.model} · quality=${item.quality}`, at: formatDate(item.createdAt, true) },
      { label: item.status === 'FAILED' ? '생성 실패' : '결과 저장', detail: item.status === 'FAILED' ? item.error : `${item.outputCount}개 결과 · private asset`, at: formatDate(item.createdAt, true) },
      ...(item.selected ? [{ label: '견적 시안 선택', detail: '선택된 결과만 견적 Revision에 첨부', at: formatDate(item.createdAt, true) }] : []),
    ]} /></Card>
  </>
}
